import { FormikProps } from 'formik';
import React from 'react';
import DomainForm, { DomainFormState } from '../../Forms/DomainForm';

export interface CreateDomainFormProps {
  formikProps: FormikProps<DomainFormState>;
}

const CreateDomainForm: React.FC<CreateDomainFormProps> = ({ formikProps }) => {
  return (
    <div className="py-2 flex flex-col gap-4 w-full">
      <DomainForm
        protocolValue={formikProps.values.protocol}
        setProtocolValue={(value) => formikProps.setFieldValue('protocol', value)}
        domainValue={formikProps.values.domain}
        setDomainFormState={(valueFunc) => formikProps.setValues(d => { return valueFunc(d) })}
        deleteDomainValue={() => formikProps.setFieldValue('domain', '')}
        placeholder={'www.organization.com/se-sv'}
        disabled={formikProps.isSubmitting}
        showHelperText={formikProps.errors?.domain?.length > 0 && formikProps.submitCount > 0}
        helperText={formikProps.errors.domain}
      />
    </div>
  );
};

export default CreateDomainForm;
